import React from 'react'

import Style from './Testimonial.module.css';
import Client__1 from './Images/Client_1.jpg';


const Testimonial = () => {
    return (
        <div className={Style.Testimonial__Section}>
            <div className='container'>
                <div className={Style.Testimonial__Item}>
                    <figure className={Style.Testimonial__Image}>
                        <img src={Client__1} alt='Jasmine Fleming - Freelance Writer' />
                    </figure>
                    <div className={Style.Testimonial__Content}>
                        <div className={Style.Description}>
                            <p>When I glance at the dashboard, I instantly have insight into the number of pending invoices, their expected payment dates, and the average payment duration. <strong>This tool helps me stay organized and significantly reduces the workload on my end.</strong></p>
                        </div>
                        <div className={Style.Name}>Ethan Mitchell - Freelance Writer</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonial
